import {AbstractUpload} from "./AbstractUpload";
import {Injectable} from "@angular/core";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {EnumSincronizacao} from "../../../domain/EnumSincronizacao";
import {Jornada} from "../../../domain/Jornada";
import {JornadaHttpService} from "../../persist/http/JornadaHttpService";

@Injectable()
export class UploadJornada extends AbstractUpload<Jornada>{
  constructor(service: JornadaHttpService) {
    super("Jornada", service, Jornada);
  }

  override async getPendencias(): Promise<any[]>{
    const repo = LocalDataSource.getRepository(Jornada)
    return repo.find({
      where: {situacao: EnumSincronizacao.ENVIAR},
    })
  }

  override transformBeforeSend(items: Jornada[]): any[]{
    items.forEach(i=>{
      delete i.situacao
    })
    return items
  }

}
